const Gradients = Object.freeze({
    primary: 'linear-gradient(135deg, #00FFED 0%, #19D7E7 22.96%, #7F4AD9 45.31%, #AF1FC6 66.73%, #DF02C0 100%)',
    gold: 'linear-gradient(225deg, #FABB00 0%, #D0388D 59.29%, #9A1A89 100%)',
    plus: 'linear-gradient(246deg, #F9AE4A 13%, #C209C1 100%)',
    pro: 'linear-gradient(60.72deg, #0E00AC -11%, #FF34F9 100%)',
    eggsellent: 'linear-gradient(315deg, #FFD15A 14.64%, #FFB017 85.36%)',
    lotus: 'linear-gradient(315deg, #B5B5FF 14.64%, #FBC7D4 85.36%)',
    aura: 'linear-gradient(315deg, #FBEAC9 14.64%, #ABB8FD 84.73%)',
    tangerine: 'linear-gradient(105deg, #BDE0A2 1.35%, #FF9658 100%)',
    valentine: 'linear-gradient(315deg, #F44097 25%, #FC67FA 75%)',
    /** @deprecated */
    dusk: 'linear-gradient(165.96deg, #5299BE 0%, #E54A39 51.56%, #376C34 100%)',
    /** @deprecated */
    desert: 'linear-gradient(166.24deg, #CB8160 0%, #323539 101.67%)',
    /** @deprecated */
    sunrise: 'linear-gradient(165.96deg, #E9B77F 0%, #E51E2B 55.73%, #352CB6 100%)',
    /** @deprecated */
    sandyStorm: 'linear-gradient(166.19deg, #FFB3B3 0%, #2D5A6B 101.39%)',
    /** @deprecated */
    venus: 'linear-gradient(166.19deg, #FFADFF 0%, #379087 50.7%, #BD382A 101.39%)',
    /** @deprecated */
    sahara: 'linear-gradient(166.19deg, #FFFF6F 0%, #84403D 50.7%, #553D36 101.39%)',
    /** @deprecated */
    alien: 'linear-gradient(166.19deg, #56BAC0 0%, #CD7861 50.7%, #5C22C3 101.39%)',
    /** @deprecated */
    midnight: 'linear-gradient(166.19deg, #FFB4B4 0%, #5C2550 50.7%, #285D74 101.39%)',
    /** @deprecated */
    userPlus: 'linear-gradient(246.37deg, #F9AE4A 13.41%, #C209C1 82.6%)',
    /** @deprecated */
    userPro: 'linear-gradient(60.72deg, #0E00AC -11%, #FF34F9 86.67%)',
});

export { Gradients };
